function statementSupportedRadioDirective(): ng.IDirective {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            statement: "="
        },
        templateUrl: "app/funding/directives/partials/statementSummary.html"
    };
}
export = statementSupportedRadioDirective;
